<template>
    <div class="container-fluid">

        <div id="builder" class="row justify-content-center" v-bind:class="{ 'template' : isTemplate}">
            <div class="col">
                <div class="card">
                    <div class="card-header">
    
                        <div class="row d-flex">

                            <div class="col-2 col-sm-3 order-1 order-sm-0">
                              <ul class="nav nav-pills card-header-pills justify-content-start">
                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1" href="#" @click="toggleBlocks"><i :class="{'fa':true,'fa-arrow-right':!blocksNavActive,'fa-arrow-left':blocksNavActive,}"></i></a>
                                </li>
                              </ul>
                            </div>

                            <div class="col-12 col-sm-6 order-0 order-sm-1">
                              <h4 class="pt-1 mb-0 pb-1 text-center"><span class="deck-name" @click="launchNamePop">{{ deckName }}</span></h4>
                            </div>

                            <div class="col-10 col-sm-3 order-2 order-sm-2 pr-0">
                              <ul class="nav nav-pills card-header-pills justify-content-end w-100">

                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1 d-none" href="#" @click="debugObject('block',blocks)" title="Debug"><i class="fa fa-star"></i></a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1 d-none" href="#" @click="debugObject('blockSettings',blockSettings)" title="Debug"><i class="fa fa-star-o"></i></a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1" :href="'/deck/preview/'+deckId" @click="saveDeck('autosave')" target="_blank" title="Preview"><i class="fa fa-eye"></i></a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1" href="#" @click="launchSettingsPop" title="Deck Settings"><i class="fa fa-cog"></i></a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1" href="#" @click="launchBackgroundPop" title="Set Background"><i class="fa fa-paint-brush"></i></a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1" href="#" @click="saveDeck" title="Save"><i class="fa fa-save"></i></a>
                                </li>
                                <li class="nav-item" v-if="!isTemplate">
                                    <a class="btn btn-primary" href="#" @click="initSend" title="Save & Send"><i class="fa fa-rocket"></i></a>
                                </li>
                                <li class="nav-item" v-if="isTemplate">
                                    <a class="btn btn-primary" href="/deck/templates" title="Close Builder"><i class="fa fa-sign-out"></i></a>
                                </li>
                                
                              </ul>
                            </div>

                          </div>
                    </div>

                    <div class="card-body p-0 builder-container" id="builderContainer">

                        <div class="row">

                            <div class="col-12 col-md-3 builder-blocks-nav" v-show="blocksNavActive" id="blocksNav">

                                  <a class="btn btn-primary btn-sm builder-block-nav-close d-none" href="javascript:;" @click="closeBlockNav()"><i class="fa fa-close"></i></a>

                                  <b-nav vertical >

                                      <b-nav-item v-for="blocktemplates in blocktemplatesnav" :key="blocktemplates.id"  class="block-template-nav" v-if="blocktemplates.block_templates.length">

                                          <b-button :id="'accordion_'+blocktemplates.id+'_button'" block squared v-b-toggle="'accordion_' + blocktemplates.id" varient="outline-primary">{{ blocktemplates.name }}</b-button>
                                        
                                          <b-collapse :id="'accordion_'+blocktemplates.id" role="tabpanel" @shown="scrollBlockNav(blocktemplates.id)">

                                            <draggable :group="{ name: 'blocks', pull: 'clone', put: false }" :sort="false"  :clone="initCloneBlock" :list="blocktemplates.block_templates">
                                              <div v-for="blocktemplate in blocktemplates.block_templates" :data-blockTemplateId="blocktemplate.id" class="blocktemplate">
                                                <a :id="'accordion_'+blocktemplates.id+'_blockSelectLink_'+blocktemplate.id" class="block-select" href="javascript:;" @click="selectBlock" :data-blockTemplateId="blocktemplate.id">
                                                  <img class="block-preview" :src="blocktemplate.thumbnail"/>
                                                  <div class="block-name">{{ blocktemplate.name }} {{ blocktemplate.user_id }}</div>
                                                </a>
                                                <div v-if="blocktemplates.user_id" class="block-nav-controls">
                                                  <i class="block-control btn btn-light fa fa-trash" @click="deleteCustomBlock(blocktemplate.id)"></i>
                                                </div>
                                                <div v-if="blocktemplates.company_id && manageCompanyCards" class="block-nav-controls">
                                                  <i class="block-control btn btn-light fa fa-trash" @click="deleteCompanyBlock(blocktemplate.id)"></i>
                                                </div>
                                              </div>
                                            </draggable>

                                          </b-collapse>    

                                      </b-nav-item>

                                  </b-nav>

                            </div>
                            <div class="col builder-build-area sizzledeck" id="buildArea" :style="{ backgroundImage: 'url('+deckBackground+')' }">
                              
                              <draggable v-model="blocks" group="blocks" @start="closeSettings();updateBlocksFromInline();" @end="initMediumEditor();" @add="selectBlock" handle=".handle" class="draggable-area">
                                <div v-for="(block, index) in blocks" :key="block.id" class="editable-block-wrap">

                                  <div :ref="'editable_block_'+index" :id="'editable_block_'+index" class="editable-block" v-html="block.html" :data-blockIndex="index" @click="closeSettings()"></div> 

                                  <div class="block-controls">
                                    <i v-if="index != 0" class="block-control btn btn-light fa fa-arrow-up" @click="moveBlockUp(index)"></i>
                                    <i class="block-control btn btn-light fa fa-arrows handle" @mousedown="destroyMediumEditor();" @mouseup="initMediumEditor();" @click="initMediumEditor();"></i>
                                    <i v-if="index < (blocks.length -1)" class="block-control btn btn-light fa fa-arrow-down" @click="moveBlockDown(index)"></i>
                                    <i class="block-control btn btn-light fa fa-edit" @click="openSettings(index)"></i>
                                    <i class="block-control btn btn-light fa fa-copy" @click="duplicateBlock(index)"></i>
                                    <i class="block-control btn btn-light fa fa-trash" @click="removeBlock(index)"></i>
                                  </div>
                                </div>
                              </draggable>

                            </div>
                            <div :class="{'col-12 col-md-3 builder-block-settings':true,'col-md-8':editingImage}" v-show="blockSettingsActive">
                                <nav class="navbar bg-light ">
                                  <a class="btn btn-primary mr-1 builder-block-settings-close" href="#" @click="closeSettings()"><i class="fa fa-close"></i></a>
                                  

                                    <div class="d-flex flex-column">
                                    <template v-for="(blockSetting, index) in blockSettings">

                                    	  <div v-if="disableSummernote != true">

	                                        <div v-if="blockSetting.type == 'singleline'">
	                                          <h3 class="mt-4" v-text="blockSetting.label"></h3>
	                                          <div editable class="summernoteTargetHeading" :data-reference="blockSetting.reference" :data-blockIndex="blockSetting.blockIndex" v-html="blockSetting.html"></div>
	                                          
	                                        </div>

	                                        <div v-if="blockSetting.type == 'multiline'">
	                                          <h3 class="mt-4" v-text="blockSetting.label"></h3>
	                                          
	                                          <div class="summernoteTargetText" :data-reference="blockSetting.reference" :data-blockIndex="blockSetting.blockIndex" v-html="blockSetting.html"></div>
	                                        </div>

	                                        <div v-if="blockSetting.type == 'plaintext'">
	                                          <h3 class="mt-4" v-text="blockSetting.label"></h3>                                          
	                                          <input class="w-100" type="text" :data-reference="blockSetting.reference" :data-blockIndex="blockSetting.blockIndex" v-model="blockSetting.html" @change="updateBlockFromSettings" @keyup="updateBlockFromSettings" />
	                                        </div>

                                    	  </div>

                                        <div v-if="blockSetting.type == 'image-with-cropper'">

                                          <h3 class="mt-4" v-text="blockSetting.label"></h3>
                                          

                                          <upload-image :image="blockSetting.image" :reference="blockSetting.reference" @newImageSrc="onNewImageSrc" :showButton="false"></upload-image>

                                          <div class="text-center">
                                            <b-button v-b-modal.modal-medialib-image>Choose From Library</b-button>

                                            <b-modal id="modal-medialib-image" title="Media Library" size="xl" :hide-footer="true">
                                              <sd-media-manager prefix="/sd-media/" :reference="blockSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibrary"></sd-media-manager>
                                            </b-modal>

                                          </div>

                                        </div>

                                        <div v-if="blockSetting.type == 'image'">

                                          <h3 class="mt-4" v-text="blockSetting.label"></h3>
                                          

                                          <img class="w-100 pb-3" :src="blockSetting.image" :reference="blockSetting.reference" />

                                          <div class="text-center">
                                            <b-button v-b-modal="'modal-medialib-image_'+blockSetting.reference">Replace Image</b-button>

                                            <b-modal :id="'modal-medialib-image_'+blockSetting.reference" :ref="'modal-medialib-image_'+blockSetting.reference" title="Media Library" size="xl" :hide-footer="true">
                                              <sd-media-manager prefix="/sd-media/" :reference="blockSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibrary"></sd-media-manager>
                                            </b-modal>

                                          </div>

                                          <div v-if="!(typeof blockSetting.link === 'undefined')">
                                            <label class="pr-2 pt-2">Link:</label>                                      
                                            <input class="w-100 mb-2" :ref="'link_'+blockSetting.blockIndex+'_'+blockSetting.reference" type="url" :data-reference="blockSetting.reference" :data-blockIndex="blockSetting.blockIndex" v-model="blockSetting.link" @change="updateBlockFromSettings" @blur="updateBlockFromSettings" />                                          
                                            <div v-if="$refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference] && $refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference][0]">
                                              <small v-if="!$refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference][0].validity.valid" class="text-danger">URL is not valid. Please make sure it begins with http:// or https://</small>
                                            </div>
                                          </div>

                                        </div>

                                        <div v-if="blockSetting.type == 'avatar'">

                                          <h3 class="mt-4" v-text="blockSetting.label"></h3>

                                          <upload-avatar :image="blockSetting.image" :reference="blockSetting.reference" @newImageSrc="onNewImageSrc" :newimagefromlib="newImageFromLib" @editingImage="onEditingImage"></upload-avatar>

                                          <div class="text-center">
                                            <b-button v-b-modal.modal-medialib-avatar>Choose From Library</b-button>

                                            <b-modal id="modal-medialib-avatar" title="Media Library" size="xl" :hide-footer="true">
                                              <sd-media-manager prefix="/sd-media/" :reference="blockSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibraryForAvatar"></sd-media-manager>
                                            </b-modal>

                                          </div>


                                        </div>

                                        <div v-if="blockSetting.type == 'video'" class="">

                                          <h3 class="mt-4" v-text="blockSetting.label"></h3>

                                          <div class="input-group">
                                              <input type="text" class="form-control" :data-blockIndex="blockSetting.blockIndex" :data-reference="blockSetting.reference" :value="blockSetting.video" />
                                              <span class="input-group-btn">
                                                  <button type="button" class="btn btn-primary" @click="updateVideo(blockSetting.reference)">Update</button>
                                              </span>
                                          </div>

                                          
                                        </div>

                                        <div v-if="blockSetting.type == 'button'" class="w-100">

                                          <h3 class="mt-4 mb-3" v-text="blockSetting.label"></h3>
                                          
                                          <div v-if="blockSetting.hasOwnProperty('link')">
                                            <label v-if="typeof blockSetting.linklabel !== 'undefined'" class="pr-2 pt-2">{{ blockSetting.linklabel }}:</label>                                      
                                            <label v-else class="pr-2 pt-2">Link:</label>                                      
                                            <input class="w-100 mb-2" :ref="'link_'+blockSetting.blockIndex+'_'+blockSetting.reference" 

                                            :type="typeof blockSetting.linkprepend == 'undefined' && typeof blockSetting.linkappend == 'undefined' ? 'url' : 'text'" 

                                            :data-reference="blockSetting.reference" :data-blockIndex="blockSetting.blockIndex" v-model="blockSetting.link" @change="updateBlockFromSettings" @blur="updateBlockFromSettings" />                                          
                                            <div v-if="$refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference] && $refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference][0]">
                                              <small v-if="!$refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference][0].validity.valid" class="text-danger">URL is not valid. Please make sure it begins with http:// or https://</small>
                                            </div>
                                          </div>

                                          <div v-if="blockSetting.hasOwnProperty('text')">
                                            <label class="pr-2 pt-2">Button Text:</label>                                    
                                            <input class="w-100 mb-2" type="text" :data-reference="blockSetting.reference" :data-blockIndex="blockSetting.blockIndex" v-model="blockSetting.text" @change="updateBlockFromSettings" @keyup="updateBlockFromSettings" />
                                          </div>
                                          <div v-if="blockSetting.hasOwnProperty('background')" class="input-group mb-3">
                                            
                                            <label class="pr-2 pt-2 w-100">Button Colour:</label>
                                            <div class="w-100">
                                            <v-swatches 
                                              v-model="blockSetting.background" 
                                              @input="updateBlockFromSettings"
                                              :colors="swatchplusdefault(swatches,blockSetting.reference)"
                                              backgroundColor="transparent"
                                              inline
                                              :wrapper-style="{ paddingLeft: '0px', paddingTop: '0px' }"
                                              swatch-size="30"
                                            ></v-swatches> 
                                            </div>
                                            <div class="w-100">
                                              <a v-b-toggle href="#buttonBackgroundCollapse" class="text-muted" @click.prevent>
                                                <span class="when-open">Hide</span><span class="when-closed">Show</span> Advanced Picker <span class="when-open"><i class="fa fa-angle-double-up" aria-hidden="true"></i></span><span class="when-closed"><i class="fa fa-angle-double-down" aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                            <b-collapse id="buttonBackgroundCollapse">
                                              <vue-color 
                                                :value="blockSetting.background" 
                                                @input="setVueBackground($event,blockSetting.reference)" 
                                                disableAlpha 
                                                :presetColors="[]"
                                              ></vue-color>
                                            </b-collapse>
                                          </div>

                                          <div v-if="blockSetting.hasOwnProperty('color')" class="input-group mb-3">

                                            <label class="pr-2 pt-2 w-100">Button Text Colour:</label>
                                            <div class="w-100">
                                            <v-swatches 
                                              v-model="blockSetting.color" 
                                              @input="updateBlockFromSettings"
                                              :colors="swatchplusdefault(swatches,blockSetting.reference)"
                                              backgroundColor="transparent"
                                              inline
                                              :wrapper-style="{ paddingLeft: '0px', paddingTop: '0px' }"
                                              swatch-size="30"
                                            ></v-swatches> 
                                            </div>
                                            <div class="w-100">
                                              <a v-b-toggle href="#buttonColorCollapse" class="text-muted" @click.prevent>
                                                <span class="when-open">Hide</span><span class="when-closed">Show</span> Advanced Picker <span class="when-open"><i class="fa fa-angle-double-up" aria-hidden="true"></i></span><span class="when-closed"><i class="fa fa-angle-double-down" aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                            <b-collapse id="buttonColorCollapse">
                                              <vue-color 
                                                :value="blockSetting.color" 
                                                @input="setVueColor($event,blockSetting.reference)" 
                                                disableAlpha 
                                                :presetColors="[]"
                                                swatch-size="30"
                                              ></vue-color>
                                            </b-collapse>
                                                                        

                                          </div>
                                          
                                        </div>

                                        <div v-if="blockSetting.type == 'showhide'">
                                          
                                          <div class="form-check">
                                            <input type="checkbox" class="form-check-input" v-model="blockSetting.state" :id="'showhide_'+blockSetting.reference" @change="updateBlockFromSettings">
                                            <label class="form-check-label" :for="'showhide_'+blockSetting.reference" v-text="">{{ blockSetting.label }}</label>
                                          </div>

                                        </div>


                                        <div v-if="blockSetting.type == 'link'" class="w-100">

                                          <h3 class="mt-4 mb-3" v-text="blockSetting.label"></h3>
                                          
                                            <label v-if="typeof blockSetting.linklabel !== 'undefined'" class="pr-2 pt-2">{{ blockSetting.linklabel }}:</label>                                      
                                            <label v-else class="pr-2 pt-2">Link:</label>                                       
                                            <input class="w-100 mb-2" :ref="'link_'+blockSetting.blockIndex+'_'+blockSetting.reference" type="url" :data-reference="blockSetting.reference" :data-blockIndex="blockSetting.blockIndex" v-model="blockSetting.link" @change="updateBlockFromSettings" @blur="updateBlockFromSettings" />                                          
                                            <div v-if="$refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference] && $refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference][0]">
                                              <small v-if="!$refs['link_'+blockSetting.blockIndex+'_'+blockSetting.reference][0].validity.valid" class="text-danger">URL is not valid. Please make sure it begins with http:// or https://</small>
                                            </div>

                                        </div>


                                        <div v-if="blockSetting.type == 'background'" class="w-100 order-12">

                                          <h3 class="mt-4 mb-3" v-text="blockSetting.label"></h3>


                                          <div v-if="blockSetting.hasOwnProperty('skin')" class="input-group mb-3">

                                              <label class="pr-2 pt-2">Text Colour:</label>
                                              <b-form-select v-model="blockSetting.skin" @change="updateBlockFromSettings">
                                                <option value="light">Default (Company Text Colour)</option>
                                                <option value="dark">Inverted (Card Background Colour)</option>
                                              </b-form-select>

                                          </div>

                                          <div v-if="blockSetting.hasOwnProperty('color')" class="input-group mb-3">
                                            
                                            <label class="pr-2 pt-2">Card Background Colour:</label>


                                            <div class="w-100">
                                            <v-swatches 
                                              v-model="blockSetting.color" 
                                              @input="updateBlockFromSettings"
                                              :colors="swatches"
                                              backgroundColor="transparent"
                                              inline
                                              :wrapper-style="{ paddingLeft: '0px', paddingTop: '0px' }"
                                              swatch-size="30"
                                            ></v-swatches> 
                                            </div>
                                            <div class="w-100">
                                              <a v-b-toggle href="#backgroundColorCollapse" class="text-muted" @click.prevent>
                                                <span class="when-open">Hide</span><span class="when-closed">Show</span> Advanced Picker <span class="when-open"><i class="fa fa-angle-double-up" aria-hidden="true"></i></span><span class="when-closed"><i class="fa fa-angle-double-down" aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                            <b-collapse id="backgroundColorCollapse">
                                              <vue-color 
                                                :value="blockSetting.color ? blockSetting.color : deckGroundColor" 
                                                @input="setVueColor($event,blockSetting.reference)" 
                                                disableAlpha 
                                                :presetColors="[]"
                                                swatch-size="30"
                                              ></vue-color>
                                            </b-collapse>


                                          </div>

                                          <div  v-if="blockSetting.hasOwnProperty('image')" class="input-group mb-3"> 

                                              <div class="text-center">
                                                <label class="pr-2">Background Image:</label><b-button v-b-modal.modal-medialib-blockbackground variant="primary" title="Choose Image"><i class="fa fa-image"></i></b-button> <b-button @click="removeBlockSettingImage(blockSetting.reference)" title="Clear Image"><i class="fa fa-trash"></i></b-button>

                                                <b-modal id="modal-medialib-blockbackground" title="Media Library" size="xl" :hide-footer="true">
                                                  <sd-media-manager prefix="/sd-media/" :reference="blockSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibraryForBlockBackground"></sd-media-manager>
                                                </b-modal>

                                              </div>

                                          </div>
                                          
                                        </div>

                                    </template>
                                    </div>
                                  
                                    <div class="input-group mt-3">
                                      <button type="button" class="btn btn-primary" @click="launchSetCardName"><i class="fa fa-save"></i> Save as Custom Card Template</button>
                                    </div>
                                    <div v-if="manageCompanyCards" class="input-group mt-3">
                                      <button type="button" class="btn btn-secondary" @click="launchSetCompanyCardName"><i class="fa fa-save"></i> Save as Company Card Template</button>
                                    </div>

                                </nav>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        
        
        <b-modal ref="deck-settings-modal" size="m" hide-footer title="Deck Settings" body-class="pt-0">
            <b-form-checkbox v-model="showProfile" name="check-button" switch>
            Show Profile Pic in Deck Header
            </b-form-checkbox>

            <hr />

            <b-form-checkbox class="mt-3" v-model="dynamicOgImage" name="check-button" switch>
            Automatically Set Share Image
            </b-form-checkbox>
            <p class="text-muted"><small>Toggle this off to manually set the the image used in 'link previews'</small></p>
            <div class="ogImageContiner" v-if="!dynamicOgImage">
              <img v-if="staticOgImage" class="w-100 mt-3" v-bind:src="staticOgImage" @click="launchOgImagePop" title="Set Share Image" />
              <a v-else class="btn btn-primary d-block mt-3" href="#" @click="launchOgImagePop" title="Set Share Image">Open Media Library</a>
            </div>

            <hr v-if="!isTemplate" />
            <p  v-if="!isTemplate" class="text-muted"><small>Converts the current deck to a deck template.</small></p>
            <a  v-if="!isTemplate" class="btn btn-secondary d-block mt-3" href="#" @click="launchTemplateDeckPop">Convert to Template Deck</a>

        </b-modal>
        
        <b-modal id="template-deck-modal" ref="template-deck-modal" size="l" @ok="onConvertToTemplate" title="Convert to Template Deck" body-class="pt-0">
            <p>Are you sure you want to convert this deck to a template?</p>
        </b-modal>

        <b-modal id="choose-ogimage-modal" ref="choose-ogimage-modal" size="xl" hide-footer title="Choose Share Image" body-class="pt-0">
          <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="onSelectedImageFromLibraryForOgImage"></sd-media-manager>
        </b-modal>
        <b-modal ref="choose-background-modal" size="xl" hide-footer title="Choose Deck Background" body-class="pt-0">
          <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="onSelectedImageFromLibraryForBackground" defaultTab="backgrounds"></sd-media-manager>
        </b-modal>
        
        <b-modal ref="modal-medialib-inline-image" id="modal-medialib-inline-image" title="Media Library" size="xl" :hide-footer="true">
            <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="onSelectedImageFromLibraryForInlineImage"></sd-media-manager>
        </b-modal>

        <b-modal v-if="!deckId" ref="set-deckname-modal" title="New Deck" hide-footer body-class="mt-1 mb-1" @ok="onSetName" @cancel="cancelNew" noCloseOnBackdrop noCloseOnEsc hideHeaderClose>

            <h5 v-if="templates.length">Create Deck From Template:</h5>

            <div v-if="templates.length" class="input-group">
              <select class="custom-select" ref="select-template">
                <option value="" selected>Choose a template...</option>
                <option v-for="template in templates" :value="template.deck_id">{{ template.name }}</option>
              </select>
              <div class="input-group-append">
                <button class="btn btn-primary" type="button" @click="createFromTemplate">Select</button>
              </div>
            </div>

            <div v-if="templates.length" class="row mt-4 mb-3">
                <div class="col"><hr></div>
                <div class="col-auto col-auto pt-1 text-muted">OR</div>
                <div class="col"><hr></div>
            </div>


            <h5 v-if="templates.length">Create Blank Deck:</h5>

            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-default">Deck Title</span>
              </div>
              <input ref="set-deckname" type="text" class="form-control" :value="deckName" @keyup.enter="onSetName">
            </div>
            <small class="form-text text-muted">Please Note: The deck title is used in the final deck URL.</small>

            <div class="d-flex justify-content-between mt-3">
              <b-button variant="secondary" @click="cancelNew">
                Cancel
              </b-button>
              <b-button variant="primary" @click="onSetName">
                OK
              </b-button>
            </div>


        </b-modal>

        <b-modal v-else ref="set-deckname-modal" title="Deck Title" @ok="onSetName" @cancel="onCancelSetName">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-default">Deck Title</span>
              </div>
              <input ref="set-deckname" type="text" class="form-control" :value="deckName" @keyup.enter="onSetName">
            </div>
            <small class="form-text text-muted">Please Note: The deck title is used in the final deck URL.</small>
        </b-modal>


        <b-modal  ref="set-cardname-modal" title="Card Name" @ok="saveAsCustomBlock">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-default">Card Name</span>
              </div>
              <input ref="set-cardname" type="text" class="form-control" value="Custom Card">
            </div>
        </b-modal>
        
        <b-modal  ref="set-companycardname-modal" title="Card Name" @ok="saveAsCompanyBlock">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-default">Card Name</span>
              </div>
              <input ref="set-companycardname" type="text" class="form-control" value="Company Card">
            </div>
        </b-modal>
        

    </div>
</template>

<script>
  import axios from 'axios';
  import Noty from 'noty';

  import Verte from 'verte';
  import 'verte/dist/verte.css';


  import VSwatches from 'vue-swatches'
  import "vue-swatches/dist/vue-swatches.min.css"

  import VueColor from 'vue-color/src/components/Sketch.vue';


  import rangy from 'rangy';
  import 'rangy/lib/rangy-classapplier';


  import html2canvas from 'html2canvas';

    export default {
        mounted() {
          var vm = this;
          vm.csrfToken = $('meta[name="csrf-token"]').attr('content');

          if(vm.deckId){
            vm.initBuilder();
          }else{
            vm.blocksNavActive=false;
            vm.getDeckDefaults();
            vm.getTemplates();
            vm.$refs['set-deckname-modal'].show();
          }

        },
        updated(){
 
        },
        components: {
          'summernote' : require('summernote'),
           Verte,
           VSwatches,
           'vue-color' : VueColor,
        },
        props: [
            'id',
        ],
        data: function(){

            return {
                deckId: this.id,
                deckName: null,
                deckTemplateName: null,
                deckBackground: null,
                deckHeadingFont: null,
                deckBodyFont: null,
                deckAccentColor: null,
                deckSecondaryColor: null,
                deckTertiaryColor: null,
                deckContrastColor: null,
                deckGroundColor: null,
                swatches: [],

                manageCompanyCards: false,

                deckDefaults: [],
                blocktemplatesnav:[],
                blocksNavActive: true,
                blockSettingsActive: false,
                blockSettingsActiveId: null,
                blockSettingsActiveRef: null,
                blockSettings:[],
                blocks:[],

                newImageFromLib:'',

                editorSettingsSingleline:{
                  modules: {
                    toolbar: [
                      ['bold', 'italic', 'underline', 'strike'],[{ 'color': [] }, { 'background': [] }],  
                      [{ 'script': 'sub'}, { 'script': 'super' }],
                      ['link'],
                      ['clean'],
                    ],
                  },
                  blots: {
                    block: []
                  }
                },

                editorSettingsMultiline:{},

                editingImage: false,

                showProfile: true,

                dynamicOgImage: true,
                staticOgImage: null, 

                disableSummernote: true,

                swatches: ['#F64272', '#F6648B', '#F493A7', '#F891A6', '#FFCCD5', ''],

                isTemplate: false,
                templates:[],

            }
        },

        methods: {

          debugObject: function(label,myObject){
			       console.log(label,JSON.stringify(myObject, null, 4));
             this.$forceUpdate();
          },
          cancelNew: function(){
            window.location.href = "/deck/drafts/";
          },
          initBuilder: async function(){

            var vm = this;
            
            vm.getDeckSettings();

            // AutoSave            
            setInterval(function(){ vm.saveDeck('autosave');}, 300000);

          },
          getDeckDefaults: function(){
            var vm = this;

            axios.get('/deck/defaults').then(response => {

              vm.deckDefaults = response.data;

              if(vm.deckBackground == null){      vm.deckBackground = response.data.background; }
              if(vm.deckHeadingFont == null){     vm.deckHeadingFont = response.data.heading_font; }
              if(vm.deckBodyFont == null){        vm.deckBodyFont = response.data.body_font; }
              if(vm.deckAccentColor == null){     vm.deckAccentColor = response.data.accent_color; }
              if(vm.deckSecondaryColor == null){  vm.deckSecondaryColor = response.data.secondary_color; }
              if(vm.deckTertiaryColor == null){   vm.deckTertiaryColor = response.data.tertiary_color; }
              if(vm.deckContrastColor == null){   vm.deckContrastColor = response.data.contrast_color; }
              if(vm.deckGroundColor == null){     vm.deckGroundColor = response.data.ground_color; }

              vm.swatches = [];
              vm.swatches.push(vm.deckAccentColor);
              if(vm.deckSecondaryColor !== vm.deckAccentColor){ vm.swatches.push(vm.deckSecondaryColor); }
              if(vm.deckTertiaryColor !== vm.deckAccentColor && vm.deckTertiaryColor !== vm.deckSecondaryColor){ vm.swatches.push(vm.deckTertiaryColor); }
              vm.swatches.push(vm.deckContrastColor);
              vm.swatches.push(vm.deckGroundColor);

              vm.manageCompanyCards = response.data.manage_company_cards;

              vm.getBlockTemplates();

            }).catch(() => console.warn('Oh. Something went wrong. getDeckDefaults'));

          },
          getDeckSettings: function(){

            var vm = this;

            axios.get('/deck/settings/'+this.deckId).then(response => {

              if(response.data.name){vm.deckName = response.data.name;}
              if(response.data.background){vm.deckBackground = response.data.background;}
              if(response.data.show_profile){vm.showProfile = response.data.show_profile;}
              if(response.data.og_image_static){vm.staticOgImage = response.data.og_image_static; vm.dynamicOgImage=false;}
              if(response.data.status == 'template'){
                vm.isTemplate = true;


              }
              vm.getDeckDefaults();

            }).catch(() => console.warn('Oh. Something went wrong. getDeckSettings'));

          },
          getTemplates: function(){

            var vm = this;

            axios.get('/deck/templates/list').then(response => {

              vm.templates = response.data.rows;

            }).catch(() => console.warn('Oh. Something went wrong. getTemplates'));
          },
          initMediumEditor: function(){

            var vm = this; // access vue model

            var ParagraphButton = MediumEditor.Extension.extend({
              
              name: 'paragraph',

              init: function () {
                this.classApplier = rangy.createClassApplier('p', {
                    elementTagName: 'p',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.innerHTML = '<i class="icon-paragraph"></i>';
                this.button.title = 'Body Text';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                this.base.execAction('append-p');
              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'p'){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var JumboParagraphButton = MediumEditor.Extension.extend({
              
              name: 'jumboparagraph',

              init: function () {
                this.classApplier = rangy.createClassApplier('p', {
                    elementTagName: 'p',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.innerHTML = '<i class="fa fa-header"><sup>6</sup></i>';
                this.button.title = 'XS Numbers';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                this.base.execAction('append-p');
              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'p'){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var AccentColorButton = MediumEditor.Extension.extend({
              
              name: 'accentcolor',

              init: function () {
                this.classApplierAccent = rangy.createClassApplier('accent', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierSecondary = rangy.createClassApplier('secondary', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierTertiary = rangy.createClassApplier('tertiary', {
                    elementTagName: 'span',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.classList.add('company-color-button');
                this.button.classList.add('company-accent-color-button');
                this.button.innerHTML = '<i class="fa fa-tint"><sup>1</sup></i>';
                this.button.title = 'Company Colour';

                this.on(this.button, 'click', this.handleClick.bind(this));

              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierSecondary.isAppliedToSelection()){
                  this.classApplierSecondary.toggleSelection();
                }else{
                  this.classApplierSecondary.toggleSelection();
                  this.classApplierSecondary.toggleSelection();
                }
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierTertiary.isAppliedToSelection()){
                  this.classApplierTertiary.toggleSelection();
                }else{
                  this.classApplierTertiary.toggleSelection();
                  this.classApplierTertiary.toggleSelection();
                }
                
                this.classApplierAccent.toggleSelection();
                
                this.base.checkContentChanged();
                if(this.classApplierAccent.isAppliedToSelection()){
                	this.button.parentNode.parentNode.children.forEach(function(item){
                		let btn = item.firstChild;
                		if(btn.classList.contains('company-color-button')){
                			btn.classList.remove('medium-editor-button-active');
                		}
                	});
                	this.setActive();
                }else{this.setInactive();} // Set Button active/inactive
              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'span' && node.classList.contains('accent')){
                  return true;
                }else{
                  return false;
                }
                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var SecondaryColorButton = MediumEditor.Extension.extend({
              
              name: 'secondarycolor',

              init: function () {

                this.classApplierAccent = rangy.createClassApplier('accent', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierSecondary = rangy.createClassApplier('secondary', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierTertiary = rangy.createClassApplier('tertiary', {
                    elementTagName: 'span',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.classList.add('company-color-button');
                this.button.classList.add('company-secondary-color-button');
                this.button.innerHTML = '<i class="fa fa-tint"><sup>2</sup></i>';
                this.button.title = 'Company Colour';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierAccent.isAppliedToSelection()){
                  this.classApplierAccent.toggleSelection();
                }else{
                  this.classApplierAccent.toggleSelection();
                  this.classApplierAccent.toggleSelection();
                }
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierTertiary.isAppliedToSelection()){
                  this.classApplierTertiary.toggleSelection();
                }else{
                  this.classApplierTertiary.toggleSelection();
                  this.classApplierTertiary.toggleSelection();
                }
                
                this.classApplierSecondary.toggleSelection();
                
                this.base.checkContentChanged();
                if(this.classApplierSecondary.isAppliedToSelection()){
                	this.button.parentNode.parentNode.children.forEach(function(item){
                		let btn = item.firstChild;
                		if(btn.classList.contains('company-color-button')){
                			btn.classList.remove('medium-editor-button-active');
                		}
                	});
                	this.setActive();
                }else{this.setInactive();} // Set Button active/inactive

              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'span' && node.classList.contains('secondary')){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var TertiaryColorButton = MediumEditor.Extension.extend({
              
              name: 'tertiarycolor',

              init: function () {
                this.classApplierAccent = rangy.createClassApplier('accent', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierSecondary = rangy.createClassApplier('secondary', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierTertiary = rangy.createClassApplier('tertiary', {
                    elementTagName: 'span',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.classList.add('company-color-button');
                this.button.classList.add('company-tertiary-color-button');
                this.button.innerHTML = '<i class="fa fa-tint"><sup>3</sup></i>';
                this.button.title = 'Company Colour';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {

                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierAccent.isAppliedToSelection()){
                  this.classApplierAccent.toggleSelection();
                }else{
                  this.classApplierAccent.toggleSelection();
                  this.classApplierAccent.toggleSelection();
                }
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierSecondary.isAppliedToSelection()){
                  this.classApplierSecondary.toggleSelection();
                }else{
                  this.classApplierSecondary.toggleSelection();
                  this.classApplierSecondary.toggleSelection();
                }
                
                this.classApplierTertiary.toggleSelection();
                
                this.base.checkContentChanged();
                if(this.classApplierTertiary.isAppliedToSelection()){
                	this.button.parentNode.parentNode.children.forEach(function(item){
                		let btn = item.firstChild;
                		if(btn.classList.contains('company-color-button')){
                			btn.classList.remove('medium-editor-button-active');
                		}
                	});
                	this.setActive();
                }else{this.setInactive();} // Set Button active/inactive

              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'span' && node.classList.contains('tertiary')){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });


            var useAccentcolor = 'accentcolor';
            var useSecondarycolor = 'secondarycolor';
            var useTertiarycolor = 'tertiarycolor';

            if(this.deckSecondaryColor == this.deckAccentColor){ 
              useSecondarycolor = ''; // If Secondary == Accent Color, then hide button
            }
            if(this.deckTertiaryColor == this.deckAccentColor || this.deckTertiaryColor == this.deckSecondaryColor){ 
              useTertiarycolor = ''; // If Tertiary == Accent Color || Secondary, then hide button
            }

            var inlineEditorForText = new MediumEditor('.editableText',{
                forcePlainText: true,
                buttonLabels: 'fontawesome',
                toolbar: {
                  buttons: [
                    { // Bold
                      name: 'bold',
                      aria: 'Bold',
                    }, 
                    { // Italic
                      name: 'italic',
                      aria: 'Italic',
                    }, 
                    { // Italic
                      name: 'underline',
                      aria: 'Underline',
                    }, 
                    {
                      name: 'anchor',
                      aria: 'Link',
                    },
                    'paragraph',
                    { // Heading
  		                name: 'h1',
  		                action: 'append-h3',
  		                aria: 'Headline Large',
  		                tagNames: ['h3'],
  		                contentDefault: '<b>H1</b>',
  		                classList: ['custom-class-h1'],
  		                attrs: {
  		                    'data-custom-attr': 'attr-value-h1'
  		                }
    		            },            
    		            { // Subheading
    		                name: 'h2',
    		                action: 'append-h4',
    		                aria: 'Headline Medium',
    		                tagNames: ['h4'],
    		                contentDefault: '<b>H2</b>',
    		                classList: ['custom-class-h2'],
    		                attrs: {
    		                    'data-custom-attr': 'attr-value-h2'
    		                }
    		            },          
                    { // Large Text
                      name: 'h3',
                      action: 'append-h5',
                      aria: 'Headline Small',
                      tagNames: ['h5'],
                      contentDefault: '<b>H3</b>',
                      classList: ['custom-class-h3'],
                      attrs: {
                          'data-custom-attr': 'attr-value-h3'
                      }
                    },
  		              useAccentcolor,
                    useSecondarycolor,
                    useTertiarycolor,
                    {
                      name: 'unorderedlist',
                      aria: 'Bullet Point List',
                    },
                    {
                      name:'orderedlist',
                      aria: 'Numbered List',
                    },
                    {
                      name:'justifyLeft', 
                      aria:'Left Aligned Text'
                    },
                    {
                      name:'justifyCenter', 
                      aria:'Centered Text'
                    },
                    {
                      name:'justifyRight', 
                      aria:'Right Aligned Text'
                    },
                    {
                      name: 'removeFormat',
                      aria: 'Remove Text Formatting',
                    },
                    ],
                  },
          			  extensions: {
          			  	'paragraph': new ParagraphButton(),
                    'accentcolor': new AccentColorButton(),
                    'secondarycolor': new SecondaryColorButton(),
                    'tertiarycolor': new TertiaryColorButton()
          			  },
                  placeholder: {
                    text: '' 
                  },  
                  targetBlank: true,
                  anchor: {
                      linkValidation: true
                  }
            });
            
            inlineEditorForText.subscribe('blur', function (event, editable) { // Fire on blur

              var index = $(editable).closest('.editable-block').attr('data-blockIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(editable).attr('data-reference');
              var html = $(editable).html();

              vm.blocks[index].current.find(blockSetting => blockSetting.reference == reference).content = html;  // Update the blocks data object with new current content

            });

            inlineEditorForText.subscribe('focus', function (event, editable) { // Fire on focus
              vm.closeSettings();
            });

            var inlineEditorForHeading = new MediumEditor('.editableHeading',{
              disableReturn: true,
              forcePlainText: true,
              buttonLabels: 'fontawesome',
              toolbar: {
                buttons: [
                  { // Bold
                    name: 'bold',
                    aria: 'Bold',
                  }, 
                  { // Italic
                    name: 'italic',
                    aria: 'Italic',
                  }, 
                  { // Italic
                    name: 'underline',
                    aria: 'Underline',
                  }, 
                  {
                    name: 'anchor',
                    aria: 'Link',
                  },
                  {
                    name: 'removeFormat',
                    aria: 'Remove Text Formatting',
                  },
                  ],
              },
              placeholder: {
                text: '' 
              }
            });

            
            inlineEditorForHeading.subscribe('blur', function (event, editable) { // Fire on blur

              var index = $(editable).closest('.editable-block').attr('data-blockIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(editable).attr('data-reference');
              var html = $(editable).html();

              vm.blocks[index].current.find(blockSetting => blockSetting.reference == reference).content = html;  // Update the blocks data object with new current content
              
            });     


            inlineEditorForHeading.subscribe('focus', function (event, editable) { // Fire on focus
              vm.closeSettings();
            });


            var inlineEditorForJumbo = new MediumEditor('.editableJumbo',{
              forcePlainText: true,
              buttonLabels: 'fontawesome',
              toolbar: {
                buttons: [
                  { // Bold
                    name: 'bold',
                    aria: 'Bold',
                  }, 
                  { // Italic
                    name: 'italic',
                    aria: 'Italic',
                  }, 
                  { // Italic
                    name: 'underline',
                    aria: 'Underline',
                  }, 
                  {
                    name: 'anchor',
                    aria: 'Link',
                  },
                  { // Heading
                    name: 'h1',
                    action: 'append-h2',
                    aria: 'XXL Numbers',
                    tagNames: ['h2'],
                    contentDefault: '<b>H1</b>',
                    classList: ['custom-class-h1'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h1'
                    }
                  },            
                  { // Subheading
                      name: 'h2',
                      action: 'append-h3',
                      aria: 'XL Numbers',
                      tagNames: ['h3'],
                      contentDefault: '<b>H2</b>',
                      classList: ['custom-class-h2'],
                      attrs: {
                          'data-custom-attr': 'attr-value-h2'
                      }
                  },          
                  { // Large Text
                    name: 'h3',
                    action: 'append-h4',
                    aria: 'Large Numbers',
                    tagNames: ['h4'],
                    contentDefault: '<b>H3</b>',
                    classList: ['custom-class-h3'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h3'
                    },          
                    },          
                  { // Large Text
                    name: 'h4',
                    action: 'append-h5',
                    aria: 'Medium Numbers',
                    tagNames: ['h5'],
                    contentDefault: '<b>H4</b>',
                    classList: ['custom-class-h3'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h4'
                    },          
                    },          
                  { // Large Text
                    name: 'h5',
                    action: 'append-h6',
                    aria: 'Small Numbers',
                    tagNames: ['h6'],
                    contentDefault: '<b>H5</b>',
                    classList: ['custom-class-h3'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h5'
                    }
                  },
                  'jumboparagraph',
                  'accentcolor',
                  {
                    name:'justifyLeft', 
                    aria:'Left Aligned Text'
                  },
                  {
                    name:'justifyCenter', 
                    aria:'Centered Text'
                  },
                  {
                    name:'justifyRight', 
                    aria:'Right Aligned Text'
                  },
                  {
                    name: 'removeFormat',
                    aria: 'Remove Text Formatting',
                  },
                  ],
                },
                extensions: {
                  'jumboparagraph': new JumboParagraphButton(),
                  'accentcolor': new AccentColorButton(),
                  'secondarycolor': new SecondaryColorButton(),
                  'tertiarycolor': new TertiaryColorButton()
                },
                placeholder: {
                  text: '' 
                }
            });
            
            inlineEditorForJumbo.subscribe('blur', function (event, editable) { // Fire on blur

              var index = $(editable).closest('.editable-block').attr('data-blockIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(editable).attr('data-reference');
              var html = $(editable).html();

              vm.blocks[index].current.find(blockSetting => blockSetting.reference == reference).content = html;  // Update the blocks data object with new current content

            });

            inlineEditorForJumbo.subscribe('focus', function (event, editable) { // Fire on focus
              vm.closeSettings();
            });


            /* Plain Text ie. inline but not medium */
            $('.editablePlainText').each(function(){
              $(this).attr('contentEditable', 'true');
            });

            $('#buildArea').on('blur','.editablePlainText',function(event) {
              
              var index = $(this).closest('.editable-block').attr('data-blockIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(this).attr('data-reference');
              var html = $(this).html();

              vm.blocks[index].current.find(blockSetting => blockSetting.reference == reference).content = html;  // Update the blocks data object with new current content

            });
            $('#buildArea').on('focus','.editablePlainText',function(event) {
              vm.closeSettings();
            });


          },
          initSummernoteEditor: function(){

            var vm = this;
            $('.summernoteTargetHeading').summernote({
                fontSizes: ['10', '11', '12', '14', '18', '24', '36', '48' , '64', '82', '140', '180', '224'],
                colorButton: {
                  foreColor: '#000000',
                  backColor: 'transparent',
                },
                toolbar: [
                    ['color', ['color']],
                    ['fontsize', ['fontsize']],
                    ['style', ['bold', 'italic', 'underline','clear']],
                    ['para', ['paragraph']],
                    ['insert', ['link']],
                    ['view', ['codeview']],
                ],

                callbacks: {
                  onBlur: function() {
                    vm.blockSettings.find(blockSetting => blockSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update blockSetting
                    vm.updateBlockFromSettings(); // Update Blocks
                  },
                  onChange: function() {
                    vm.blockSettings.find(blockSetting => blockSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update blockSetting
                    vm.updateBlockFromSettings(); // Update Blocks
                  },
                  onEnter: function(e) {
                    e.preventDefault();
                  },
                  onPaste: function (e) {
                      var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                      e.preventDefault();
                      document.execCommand('insertText', false, bufferText);
                  }
                }
            });
            $('.summernoteTargetText').summernote({
                fontSizes: ['10', '11', '12', '14', '18', '24', '36', '48' , '64', '82', '140'],
                colorButton: {
                  foreColor: '#000000',
                  backColor: 'transparent',
                },
                toolbar: [
                    ['color', ['color']],
                    ['fontsize', ['fontsize']],
                    ['style', ['bold', 'italic', 'underline','clear']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                    ['view', ['codeview']],
                ],

                callbacks: {
                  onBlur: function() {
                    vm.blockSettings.find(blockSetting => blockSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update blockSetting
                    vm.updateBlockFromSettings(); // Update Blocks
                  },
                  onChange: function() {
                    vm.blockSettings.find(blockSetting => blockSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update blockSetting
                    vm.updateBlockFromSettings(); // Update Blocks
                  },
                  onPaste: function (e) {
                    var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                    e.preventDefault();
                    document.execCommand('insertText', false, bufferText);
                  }
                }
            });

          },
          destroySummernoteEditor: function(){           
            $('.summernoteTargetHeading,.summernoteTargetText').each(function(){
              $(this).summernote('destroy');
            });
          },
          destroyMediumEditor: function(){

            $('.medium-editor-element').each(function(index, el) {
              var mediumEditor = MediumEditor.getEditorFromElement($(el)[0]);
              if(mediumEditor !== null){
                 mediumEditor.destroy();
              }
              
            });

          },
          initInlineImage: function(){

            var vm = this;
            $('#buildArea').on('click','.editableImage',function(){

              vm.closeSettings();
              vm.closeBlockNav();

              vm.blockSettingsActiveId = $(this).closest('.editable-block').attr('data-blockindex');
              vm.blockSettingsActiveRef = $(this).attr('data-reference');

              vm.$refs['modal-medialib-inline-image'].show();

            });
          },
          initInlineButton: function(){

            var vm = this;
            $('#buildArea').on('click','.btn-sizzle',function(e){

              e.preventDefault();
              vm.closeSettings();
              vm.closeBlockNav();

              var blockSettingsActiveId = $(this).closest('.editable-block').attr('data-blockindex');

              vm.openSettings(blockSettingsActiveId);

            });

          },
          getBlocks: function(){

              const url = `/deck/`+ this.deckId +`/blocks`;

              var vm = this;

              axios.get(url).then(response => {

                if(response.data.length > 0){                

                response.data.forEach(function(block){

                  // Insert content
                  var blockHtml = $('<div></div>').append(block.block_template.html); // Create a holder div for jQuery to work from.

                  block.content = JSON.parse(block.content);

                  
                  block.content.forEach(function(item, index){
                    if(item.type == 'singleline' || item.type == 'multiline' || item.type == 'plaintext' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').html(item.content);
                    }
                    if(item.type == 'image' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                      if(typeof item.link !== 'undefined'){ // if has link then set
                        blockHtml.find('[data-reference="' + item.reference + '"]').attr('data-href',item.link); 
                      }
                    }
                    if(item.type == 'avatar' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'video' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'background' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.color);

                      if(item.image){
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-image',"url('"+item.image+"')"); // Update the color
                      }else{
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-image',''); // Update the color
                      }

                      blockHtml.find('[data-reference="' + item.reference + '"]').removeClass(function (index, css) {
                        return (css.match (/\bskin-\S+/g) || []).join(' '); // removes anything that starts with "skin-"
                      }).addClass('skin-'+item.skin);

                    }

                    if(item.type == 'button' ){

                      if(typeof item.link !== 'undefined'){
                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        blockHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);
                      }
                      if(typeof item.text !== 'undefined'){
                        let fullText = item.text;
                        if(typeof item.textprepend !== 'undefined'){ fullText = item.textprepend+fullText;}
                        if(typeof item.textappend !== 'undefined'){ fullText = fullText+item.textappend; }
                        blockHtml.find('[data-reference="' + item.reference + '"]').html(fullText);                      
                      }
                      if(typeof item.color !== 'undefined'){
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('color',item.color);
                      }
                      if(typeof item.background !== 'undefined'){
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.background);     
                      }

                    }

                    if(item.type == 'showhide' ){

                      // Convert to bool
                      if(item.state === 'false'){ // Convert to bool
                        item.state = false;
                      }
                      if(item.state === 'true'){ // Convert to bool
                        item.state = true;
                      }

                      if(item.state===false){
                        blockHtml.find('[data-reference="' + item.reference + '"]').addClass('d-none');
                      }else{
                        blockHtml.find('[data-reference="' + item.reference + '"]').removeClass('d-none');
                      }
                      
                    }

                    if(item.type == 'link' ){
                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        blockHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);
                    }

                  });

                  vm.blocks.push({
                    blockTemplateId: block.blocktemplate_id,
                    html: blockHtml.html(),
                    editable: block.block_template.editable,
                    current: block.content
                  });                 

                });

                }

                Vue.nextTick(function(){
                  vm.initMediumEditor();
                  vm.initInlineImage();
                  vm.initInlineButton();
                });

              }).catch(() => console.warn('Oh. Something went wrong. getBlocks'));

          },
        	getBlockTemplates: function(getblocks=true){
        		    
        		const url = `/deck/block-templates`;
            var vm = this;
            axios.get(url).then(response => {

                vm.blocktemplatesnav = response.data;  
                if(vm.deckId && getblocks){
                  vm.getBlocks();
                }
                

            }).catch(() => console.warn('Oh. Something went wrong. getBlockTemplates'));

        	},
          toggleBlocks: function(){             
                this.blocksNavActive = !this.blocksNavActive;
                this.closeSettings();
          },
          closeBlockNav: function(){             
                this.blocksNavActive = false;
          },
          scrollBlockNav: function(blockNavId){
            var vm = this;
            var blocksNav = vm.$el.querySelector("#blocksNav");
            var targetNav = vm.$el.querySelector('#accordion_'+blockNavId+'_button');
            blocksNav.scrollTop = targetNav.offsetTop;

          },
          selectBlock: function(event){

              this.closeSettings();

              var vm = this;

              switch(event.type){

                case 'click':
                  var blockTemplateId = $(event.currentTarget).attr('data-blockTemplateId');
                  var newIndex = this.blocks.length
                break;
                case 'add':
                  var blockTemplateId = event.item.attributes["data-blocktemplateid"].value;
                  var newIndex = event.newIndex;
                break;

              }

                const url = `/deck/block-template/` + blockTemplateId;

                

                var deckDefaults = this.deckDefaults;

                axios.get(url).then(response => {


                  // Insert Defaults
                  var blockHtml = $('<div></div>').append(response.data.html); // Create a holder div for jQuery to work from.

                  response.data.editable.forEach(function(item, index){
                    if(item.type == 'singleline' || item.type == 'multiline' || item.type == 'plaintext' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').html(item.content);
                    }
                    if(item.type == 'image' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                      if(typeof item.link !== 'undefined'){ // if has link then set
                        blockHtml.find('[data-reference="' + item.reference + '"]').attr('data-href',item.link); 
                      }
                    }
                    if(item.type == 'avatar' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'video' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'background' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.color);

                      if(item.image){
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-image',"url('"+item.image+"')"); // Update the color
                      }else{
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-image',''); // Update the color
                      }

                      blockHtml.find('[data-reference="' + item.reference + '"]').removeClass(function (index, css) {
                        return (css.match (/\bskin-\S+/g) || []).join(' '); // removes anything that starts with "skin-"
                      }).addClass('skin-'+item.skin);

                    }
                    if(item.type == 'button' ){
                      if(typeof item.link !== 'undefined'){

                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        blockHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);

                      }
                      if(typeof item.text !== 'undefined'){
                        let fullText = item.text;
                        if(typeof item.textprepend !== 'undefined'){ fullText = item.textprepend+fullText;}
                        if(typeof item.textappend !== 'undefined'){ fullText = fullText+item.textappend; }
                        blockHtml.find('[data-reference="' + item.reference + '"]').html(fullText);
                      }
                      if(typeof item.color !== 'undefined'){
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('color',item.color);
                      }
                      if(typeof item.background !== 'undefined'){
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.background);                      
                      }
                      
                    }
                    if(item.type == 'showhide' ){

                      // Convert to bool
                      if(item.state === 'false'){ // Convert to bool
                        item.state = false;
                      }
                      if(item.state === 'true'){ // Convert to bool
                        item.state = true;
                      }

                      if(item.state===false){
                        blockHtml.find('[data-reference="' + item.reference + '"]').addClass('d-none');
                      }else{
                        blockHtml.find('[data-reference="' + item.reference + '"]').removeClass('d-none');
                      }

                    }

                    if(item.type == 'link' ){
                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        blockHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);
                    }


                  });

                  response.data.html = blockHtml.html()



                  response.data.current = vm.copyObject(response.data.editable); // make a (non-reactive) copy of editable for current

                  // Replace User Placeholders
                  for (var prop in deckDefaults) {
                    if(deckDefaults[prop] == null){ deckDefaults[prop] = '';} // Replace word null with blank
                    response.data.html = response.data.html.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);

                    response.data.current.forEach(function(item,index){

                      switch(item.type){
                        case 'background':
                          if(typeof response.data.current[index].color !== 'undefined' && response.data.current[index].color !== null){
                            response.data.current[index].color = response.data.current[index].color.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].image !== 'undefined' && response.data.current[index].image !== null){
                            response.data.current[index].image = response.data.current[index].image.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }

                        break;
                        case 'button':
                          if(typeof response.data.current[index].link !== 'undefined' && response.data.current[index].link !== null){
                            response.data.current[index].link = response.data.current[index].link.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].text !== 'undefined' && response.data.current[index].text !== null){
                            response.data.current[index].text = response.data.current[index].text.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].color !== 'undefined' && response.data.current[index].color !== null){
                            response.data.current[index].color = response.data.current[index].color.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].background !== 'undefined' && response.data.current[index].background !== null){
                            response.data.current[index].background = response.data.current[index].background.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }


                          if(
                            typeof response.data.current[index].showhide !== 'undefined' && 
                            typeof response.data.current[index].link !== 'undefined'
                          ){
                            if(response.data.current[index].link == ''){ 
                              
                                blockHtml = $('<div></div>').append(response.data.html); // Convert back to jQuery object
                                blockHtml.find('[data-reference="' + response.data.current[index].showhide + '"]').addClass('d-none'); // do find replace
                                response.data.html = blockHtml.html() // reconvert to html
                                response.data.current.find(blockSetting => blockSetting.reference == response.data.current[index].showhide).state = false;
                              
                            }
                          }



                        break;
                        case 'showhide':
                        break;
                        case 'link':
                          response.data.current[index].link = response.data.current[index].link.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);

                          if(
                            typeof response.data.current[index].showhide !== 'undefined' && 
                            typeof response.data.current[index].link !== 'undefined'
                          ){
                            if(response.data.current[index].link == ''){ 
                              
                                blockHtml.find('[data-reference="' + response.data.current[index].showhide + '"]').addClass('d-none');
                                response.data.html = blockHtml.html()
                                response.data.current.find(blockSetting => blockSetting.reference == response.data.current[index].showhide).state = false;
                              
                            }
                          }

                        break;
                        default:
                          response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                        break;
                      }

                    });

                  }
                
                  this.blocks.splice(newIndex,0,{
                    blockTemplateId: blockTemplateId,
                    html: response.data.html,
                    editable: response.data.editable,
                    current: response.data.current
                  });               	


                //var vm = this;

                Vue.nextTick(function(){
                  vm.destroyMediumEditor();
                  // Init MediumEditor
                  vm.initMediumEditor();
                  if(event.type == 'click'){           
                    // Scroll to the bottom
                    var builderContainer = vm.$el.querySelector("#builderContainer");
                    builderContainer.scrollTop = builderContainer.scrollHeight;
                  }


                });
                

                }).catch(() => console.warn('Oh. Something went wrong. selectBlock'));                
          },
          initCloneBlock: function(value){
            
            var vm = this;

            vm.destroyMediumEditor();   // Unload Medium Editor - VERY IMPORTANT` `
            vm.closeSettings();
            vm.updateBlocksFromInline();
            
            Vue.nextTick(function(){
              vm.initMediumEditor();
            });

            return;  // Important we return nothing here so we don't add to blocks array
          },
          removeBlock: function (index) {
          		
          		var vm = this;

          		this.closeSettings();

		        this.$bvModal.msgBoxConfirm('Are you sure you want to remove this card?')
		          .then(value => {
		            if(value){

		            	vm.destroyMediumEditor();  // Unload Medium Editor - VERY IMPORTANT`	`
            			vm.updateBlocksFromInline();

		            	this.blocks.splice(index, 1);

                  Vue.nextTick(function(){
                    vm.initMediumEditor();
                  });

		            }
		          })
		          .catch(err => {
		            // An error occurred
		          })

          },
          copyObject: function(o) {
            var vm = this;
  			    if (o === null){ return null; }

  			    var output, v, key;
  			    output = Array.isArray(o) ? [] : {};
  			    for (key in o) {
  			        v = o[key];
  			        output[key] = (typeof v === "object") ? vm.copyObject(v) : v;
  			    }
  			    return output;
		      },
          duplicateBlock: function (index) {

            var vm = this;

            vm.destroyMediumEditor();
            vm.updateBlocksFromInline();
          	vm.closeSettings();

            var newIndex = index+1;
            var newBlock = vm.blocks[index];


			      vm.blocks.splice(newIndex,0,Object.assign({},vm.copyObject(newBlock)));

            Vue.nextTick(function(){
              vm.initMediumEditor();
            });


          },
          moveBlockUp: async function (index) {

            var vm = this;

            if(index != 0){
              
              vm.destroyMediumEditor();
              vm.updateBlocksFromInline();
              vm.closeSettings();

              var block = vm.blocks[index];
              var swapBlock = vm.blocks[index - 1];
              
              var blocks = vm.blocks;
              vm.blocks = [];
              blocks.splice(index,1,swapBlock);
              blocks.splice(index - 1,1,block);
              
              await this.$nextTick(); // Wait for dom to update to avoid display issues with newly duplicated blocks

              vm.blocks = blocks;

              await this.$nextTick();

              vm.initMediumEditor();

            }

          },
          moveBlockDown: async function (index) {
            var vm = this;

            if(index < (vm.blocks.length -1)){
              vm.destroyMediumEditor();  // Unload Medium Editor - VERY IMPORTANT
              vm.updateBlocksFromInline();
              vm.closeSettings();

              var block = vm.blocks[index];
              var swapBlock = vm.blocks[index + 1];

              var blocks = vm.blocks;
              vm.blocks = [];
              blocks.splice(index,1,swapBlock);
              blocks.splice(index + 1,1,block);
              
              await this.$nextTick(); // Wait for dom to update to avoid display issues with newly duplicated blocks

              vm.blocks = blocks;

              await this.$nextTick();

              vm.initMediumEditor();

            }
          },
          openSettings: function (index) {



            // Close blocksnav
            this.blocksNavActive = false;

            this.destroySummernoteEditor();              

            // Close and clear settings if required
            this.blockSettings = [];
            this.blockSettingsActive = false;
            
            var vm = this; // Pass view model to function

            this.blocks[index].current.forEach(function(item){                

              

              // Setup settings window and pass current html - will need to have if statements on this for images and video
              switch(item.type) {
                case 'image':

                  let imgobj = {
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    image: item.content
                  };

                  if(typeof item.link !== 'undefined'){
                    imgobj.link = item.link;
                  }

                  vm.blockSettings.push(imgobj);
                  break;
                case 'background':
                  if(item.color == 'accent'){item.color = vm.deckAccentColor;}
                  if(item.color == null){item.color = vm.deckGroundColor;}
                  if(item.color == 'ground'){item.color = vm.deckGroundColor;}

                  vm.blockSettings.push({
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    color: item.color,
                    image: item.image,
                    skin: item.skin
                  });
                  break;
                case 'avatar':
                  vm.blockSettings.push({
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    image: item.content
                  });
                  break;
                case 'video':
                  vm.blockSettings.push({
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    video: item.content
                  });
                  break;
                case 'button':

                  let btnobj = {
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                  };

                  if(typeof item.link !== 'undefined'){
                  
                    if(typeof item.linklabel !== 'undefined'){
                      btnobj.linklabel = item.linklabel;
                    }   
                    if(typeof item.linkprepend !== 'undefined'){
                      btnobj.linkprepend = item.linkprepend;
                    }                  
                    if(typeof item.linkappend !== 'undefined'){
                      btnobj.linkappend = item.linkappend;
                    }

                    btnobj.link = item.link;
                  }

                  if(typeof item.text !== 'undefined'){

                    if(typeof item.textprepend !== 'undefined'){
                      btnobj.textprepend = item.textprepend;
                    }                  
                    if(typeof item.textappend !== 'undefined'){
                      btnobj.textappend = item.textappend;
                    }

                    btnobj.text = item.text;
                  }
                  if(typeof item.color !== 'undefined'){
                    if(item.color == 'accent'){item.color = vm.deckAccentColor;}
                    if(item.color == 'ground'){item.color = vm.deckGroundColor;}
                    btnobj.color = item.color;
                  }
                  if(typeof item.background !== 'undefined'){
                    if(item.background == 'accent'){item.background = vm.deckAccentColor;}
                    if(item.background == 'ground'){item.background = vm.deckGroundColor;}
                    btnobj.background = item.background;
                  }

                  vm.blockSettings.push(btnobj);
                  break;
                case 'showhide':

                  if(item.state === 'false'){ // Convert to bool
                    item.state = false;
                  }
                  if(item.state === 'true'){ // Convert to bool
                    item.state = true;
                  }

                  vm.blockSettings.push({
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    state: item.state
                  });
                  break;

                case 'link':

                  let linkobj = {
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    link: item.link
                  };


                  if(typeof item.linklabel !== 'undefined'){
                    linkobj.linklabel = item.linklabel;
                  }

                  if(typeof item.linkprepend !== 'undefined'){
                      linkobj.linkprepend = item.linkprepend;
                  }                  
                  if(typeof item.linkappend !== 'undefined'){
                      linkobj.linkappend = item.linkappend;
                  }

                  vm.blockSettings.push(linkobj);
                  break;

                default:
                  vm.blockSettings.push({
                    blockIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    html: item.content
                  });
              }            


            });

            // Open the settings window
            this.blockSettingsActive = true;
            
            this.blockSettingsActiveId = index;

            Vue.nextTick(function(){vm.initSummernoteEditor()});

          },
          onNewImageSrc:function(data){        
            var vm = this;
                vm.blockSettings.find(blockSetting => blockSetting.reference == data.reference).image = data.src; // Update blockSetting
                vm.updateBlockFromSettings(); // Update Blocks
          },
          onEditingImage:function(data){  
            this.editingImage = data;
          },
          removeBlockSettingImage: function(reference){
            var vm = this;
                vm.blockSettings.find(blockSetting => blockSetting.reference == reference).image = ''; // Update blockSetting
                vm.updateBlockFromSettings(); // Update Blocks
          },
          updateVideo: function(reference){
                       
            var videoUrl = $('.builder-block-settings').find('[data-reference="' + reference + '"]').val();
            var match_found = false;
            
            // First, check for youtube video            
            var videoID = videoUrl.match(/(?:http(?:s|):|)\/\/(?:www\.|)yout(?:.*?)\/(?:embed\/|watch.*?v=|)([a-z_A-Z0-9\-]{11})/);

            if (videoID) {
                var videoID = videoID[1];
                videoUrl = 'https://www.youtube.com/embed/'+videoID+'/?rel=0'; // Format for YT embed URL
                match_found = true;
            }

            // Then check for Vimeo
            if(!match_found){
              videoID = videoUrl.match(/(?:https?:\/\/)?(?:www.)?(?:player.)?vimeo.com\/(?:[a-z]*\/)*([0-9]{6,11})[?]?.*/);
              if (videoID) {
                  var videoID = videoID[1];
                  videoUrl = 'https://player.vimeo.com/video/'+videoID+'?title=0&byline=0&portrait=0'; // Format for Vimeo embed URL
                  match_found = true;
              }
            }
            

            if(match_found){
              var vm = this;
              vm.blockSettings.find(blockSetting => blockSetting.reference == reference).video = videoUrl; // Update blockSetting
              vm.updateBlockFromSettings(); // Update Blocks
            }else{

              new Noty({
                        text: 'Oops that doesn\'t look like a valid Vimeo or YouTube link. Please check and try again.',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();
            }
            
          },
          closeSettings: function(){

            this.destroySummernoteEditor();

            // Close and clear settings window
            this.blockSettings = [];
            this.blockSettingsActive = false;

          },
          setVueColor: function(color,reference){

              var vm = this;
              vm.blockSettings.find(blockSetting => blockSetting.reference == reference).color = color.hex;
              vm.updateBlockFromSettings();

          },
          setVueBackground: function(color,reference){

              var vm = this;
              vm.blockSettings.find(blockSetting => blockSetting.reference == reference).background = color.hex;
              vm.updateBlockFromSettings();

          },
          swatchplusdefault: function(swatches,reference){

            var vm = this;

            var defaultcolors = [];
  
            if(typeof vm.blocks[vm.blockSettings.find(blockSetting => blockSetting.reference == reference).blockIndex].editable.find(blockSetting => blockSetting.reference == reference).color !== 'undefined'){
              defaultcolors.push(vm.blocks[vm.blockSettings.find(blockSetting => blockSetting.reference == reference).blockIndex].editable.find(blockSetting => blockSetting.reference == reference).color);
            }
            if(typeof vm.blocks[vm.blockSettings.find(blockSetting => blockSetting.reference == reference).blockIndex].editable.find(blockSetting => blockSetting.reference == reference).background !== 'undefined'){
              defaultcolors.push(vm.blocks[vm.blockSettings.find(blockSetting => blockSetting.reference == reference).blockIndex].editable.find(blockSetting => blockSetting.reference == reference).background);
            }
          	
          	console.log('defaultcolors',defaultcolors);

            var swatchcolors = defaultcolors.concat(swatches);

            console.log('swatchcolors',swatchcolors);

            swatchcolors = swatchcolors.filter(function(item) {
                if(item == 'accent' || item == 'ground'){
                  return false;
                }else{
                  return true;
                }
            });


            var uniqswatchcolors = [...new Set(swatchcolors)];

            return uniqswatchcolors;

          },
          updateBlockFromSettings: function(){

            console.log('allrefs',this.$refs);

            var vm = this;

            this.blockSettings.forEach(function(blockSetting){

                var targetBlockHtml = $('<div></div>').append(vm.blocks[blockSetting.blockIndex].html); // Grab the HTML of the block in the blocks for manipulation. Create a holder div for jQuery to work from.

                switch(blockSetting.type){
                  case 'singleline':
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').html(blockSetting.html); // Update the html of the block area we edited
                  break;
                  case 'multiline':
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').html(blockSetting.html); // Update the html of the block area we edited
                  break;
                  case 'plaintext':
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').html(blockSetting.html); // Update the html of the block area we edited
                  break;
                  case 'image':
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').attr('src',blockSetting.image); // Update the src of the block image
                    if(typeof blockSetting.link !== 'undefined'){ // if has link then set
                      targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').attr('data-href',blockSetting.link); 
                    }
                  break; 
                  case 'avatar':
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').attr('src',blockSetting.image); // Update the src of the block image
                  break;
                  case 'video':
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').attr('src',blockSetting.video); // Update the src of the block video
                  break;

                  case 'link':

                    let fullLink = blockSetting.link;
                    if(typeof blockSetting.linkprepend !== 'undefined'){ fullLink = blockSetting.linkprepend+fullLink;}
                    if(typeof blockSetting.linkappend !== 'undefined'){ fullLink = fullLink+blockSetting.linkappend; }
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').attr('href',fullLink);

                  break;
                  case'showhide':
                      if(blockSetting.state==='false' || blockSetting.state===false){
                        targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').addClass('d-none');
                      }else{
                        targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').removeClass('d-none');
                      }
                  break;
                  case 'background':
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').css('background-color',blockSetting.color); // Update the color

                    if(blockSetting.image){
                      targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').css('background-image',"url('"+blockSetting.image+"')"); // Update the color
                    }else{
                      targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').css('background-image',''); // Update the color
                    }

                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').removeClass(function (index, css) {
                      return (css.match (/\bskin-\S+/g) || []).join(' '); // removes anything that starts with "skin-"
                    }).addClass('skin-'+blockSetting.skin);
                    
                  break;
                  case 'button':
                  if(typeof blockSetting.link !== 'undefined'){

                    let fullLink = blockSetting.link;
                    if(typeof blockSetting.linkprepend !== 'undefined'){ fullLink = blockSetting.linkprepend+fullLink;}
                    if(typeof blockSetting.linkappend !== 'undefined'){ fullLink = fullLink+blockSetting.linkappend; }
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').attr('href',fullLink);

                    
                  }
                  if(typeof blockSetting.text !== 'undefined'){

                    let fullText = blockSetting.text;
                    if(typeof blockSetting.textprepend !== 'undefined'){ fullText = blockSetting.textprepend+fullText;}
                    if(typeof blockSetting.textappend !== 'undefined'){ fullText = fullText+blockSetting.textappend; }
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').html(fullText);

                  }
                  if(typeof blockSetting.color !== 'undefined'){
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').css('color',blockSetting.color);        
                  }
                  if(typeof blockSetting.background !== 'undefined'){       
                    targetBlockHtml.find('[data-reference="' + blockSetting.reference + '"]').css('background-color',blockSetting.background);     
                  }
                  break;
                }
                var updatedHTML = targetBlockHtml.html();

                // Remove the medium editor
                var mediumEditor = MediumEditor.getEditorFromElement($('[data-blockindex="' + blockSetting.blockIndex + '"] [data-reference="' + blockSetting.reference + '"]')[0]);
                if(mediumEditor !== null){
                  mediumEditor.destroy();
                }

                vm.blocks[blockSetting.blockIndex].html = updatedHTML; // Update the blocks data object

                switch(blockSetting.type){
                  case 'avatar':
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).content = blockSetting.image;  
                  break;
                  case 'image':
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).content = blockSetting.image;  
                    if(typeof blockSetting.link !== 'undefined'){ // If link is set then add to blockSetting
                      vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).link = blockSetting.link;
                    }
                    
                  break;
                  case 'video':
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).content = blockSetting.video;  
                  break;
                  case 'showhide':
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).state = blockSetting.state;  
                  break;

                  case 'link':
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).link = blockSetting.link;  
                  break;
                  case 'background':
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).color = blockSetting.color;  
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).image = blockSetting.image;  
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).skin = blockSetting.skin;  
                  break;
                  case 'button':
                    if(typeof blockSetting.link !== 'undefined'){
                      vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).link = blockSetting.link;  
                    }
                    if(typeof blockSetting.text !== 'undefined'){
                      vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).text = blockSetting.text;  
                    }
                    if(typeof blockSetting.color !== 'undefined'){
                      vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).color = blockSetting.color;  
                    }
                    if(typeof blockSetting.background !== 'undefined'){
                      vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).background = blockSetting.background;  
                    }


                  break;
                  default:
                    vm.blocks[blockSetting.blockIndex].current.find(blockCurrentSetting => blockCurrentSetting.reference == blockSetting.reference).content = blockSetting.html;  
                }

            });

            Vue.nextTick(function(){vm.initMediumEditor()}); // Re-apply Medium Editor

          },          
          updateBlocksFromInline: function(){

              var vm = this;

              $('.builder-build-area').find('.editable-block').each(function(index,editable) {

                  var reference = $(editable).attr('data-reference');
                  var html = $(editable).html();

                  vm.blocks[index].html = html; // Update the blocks data object with new HTML
                  
              });

          },
          onSetID: function(id){
            this.deckId = id;
          },

          onConvertToTemplate: function(e){
            
            e.preventDefault();

            const url = `/deck/make-template`;

            var vm = this;

            vm.saveDeck();

            axios.post(url,{id:vm.deckId}).then(response => {
                  
                    if(response.data.status == 'success'){

                      vm.$refs['template-deck-modal'].hide();
                      vm.isTemplate = true;

                        new Noty({
                            text: 'Conversion to Template Complete',
                            type: 'success',
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: 1000
                        }).show();

                    
                    }else{

                        new Noty({
                            text: response.data.message,
                            type: response.data.status,
                            theme: 'bootstrap-v4',
                            layout: 'topCenter',
                            timeout: 1000
                        }).show();

                    }

            }).catch( error => {

                    if(error.response.status == '419'){

                      new Noty({
                              text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show();

                    }else{

                    new Noty({
                              text: 'There has been an error, please try saving again.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show();
                  }
            });

          },
          onSetName: function(e){ 

                e.preventDefault();

                var deckname = this.$refs['set-deckname'].value;

                const url = `/deck/store`;

                var vm = this;

                axios.post(url,{id:vm.deckId,name:deckname,background:vm.deckBackground}).then(response => {
                    
                      if(response.data.status == 'success'){

                        if(vm.deckId == ''){
                          vm.deckId = response.data.payload.id;

                          window.history.pushState("", "", "/deck/edit/"+vm.deckId);

                          Vue.nextTick(function(){
                            vm.initBuilder();
                            vm.blocksNavActive=true;
                          });

                        }

                         
                        vm.deckName = response.data.payload.name;
                        
                        vm.$refs['set-deckname-modal'].hide();
                      
                        Appcues.page();
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

                }).catch( error => {

                      if(error.response.status == '419'){

                        new Noty({
                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                type: 'error',
                                theme: 'bootstrap-v4',
                                layout: 'topCenter',
                                timeout: false
                            }).show();

                      }else{

                      new Noty({
                                text: 'There has been an error, please try saving again.',
                                type: 'error',
                                theme: 'bootstrap-v4',
                                layout: 'topCenter',
                                timeout: false
                            }).show();
                    }
              });

                
          },
          onCancelSetName: function(e){
            e.preventDefault();
            var vm = this;
            
            if(this.deckName !== ''){ 
              Vue.nextTick(function(){vm.$refs['set-deckname-modal'].hide();});
            }else{
              new Noty({
                      text: 'Please enter a deck title to continue.',
                      type: 'error',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 2000
                  }).show();
            }

          },
          launchBackgroundPop: function(e){
              this.$refs['choose-background-modal'].show();
          },
          launchOgImagePop: function(e){
              this.$refs['choose-ogimage-modal'].show();
          },
          launchSettingsPop: function(e){
              this.$refs['deck-settings-modal'].show();
          },
          onSelectedImageFromLibraryForBackground: function(background){

            const url = `/deck/store`;

            axios.post(url,{id:this.deckId,background:background.src}).then(response => {
               this.deckBackground = background.src;
            }).catch(() => console.warn('Oh. Something went wrong'));
              
          },
          onSelectedImageFromLibraryForOgImage: function(image){

            const url = `/deck/store`;

            axios.post(url,{id:this.deckId,og_image_static:image.src}).then(response => {
               this.staticOgImage = image.src;
               this.$refs['choose-ogimage-modal'].hide();
            }).catch(() => console.warn('Oh. Something went wrong'));

          },
          launchNamePop: function(){
              this.$refs['set-deckname-modal'].show()
          },
          launchTemplateDeckPop: function(){
              this.$refs['deck-settings-modal'].hide();
              this.$refs['template-deck-modal'].show();
          },
          saveDeck: async function(event){

            var is_autosave = false;
            var vm = this;
            if(event == 'autosave'){is_autosave = true;}

            const url = `/deck/`+ this.deckId +`/blocks`;

            axios.post(url,{'blocks':this.blocks,'is_autosave':is_autosave}).then(response => {

              if(!response.data.status){
                  new Noty({
                        text: 'There has been an error, please try saving again.',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

              }else{

                  new Noty({
                        text: response.data.message,
                        type: response.data.status,
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 1000
                    }).show();

                  if(response.data.status == 'success' && event == 'send'){
                      window.location.href = "/deck/send/"+ vm.deckId;
                  }

              }
              
            }).catch( error => {

              if(error.response.status == '419'){

                new Noty({
                        text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: false
                    }).show()

              }else{

              new Noty({
                        text: 'There has been an error, please try saving again.',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: false
                    }).show();

              }

              

            });


          },
          initSend: function(event){
            this.saveDeck('send');
          },
          onSelectedImageFromLibrary: function(data){
            this.onNewImageSrc(data);
            this.$bvModal.hide('modal-medialib');
          },
          onSelectedImageFromLibraryForBlockBackground: function(data){
            this.onNewImageSrc(data);
            this.$bvModal.hide('modal-medialib-blockbackground');
          },
          onSelectedImageFromLibraryForAvatar: function(data){
            var vm = this;
            vm.newImageFromLib = data;
            this.$bvModal.hide('modal-medialib');
            this.$forceUpdate();
          },
          onSelectedImageFromLibraryForInlineImage: async function(data){

            var vm = this;

            vm.destroyMediumEditor(); // Must destroy Medium Editor first!!

            await this.$nextTick(); // Wait for dom to update and Medium Editor to be destroyed (element classes removed etc.)

            vm.updateBlocksFromInline();

            vm.blocks[vm.blockSettingsActiveId].current.find(blockCurrentSetting => blockCurrentSetting.reference == vm.blockSettingsActiveRef).content = data.src;

            var blockHtml = $('<div></div>').append(vm.blocks[vm.blockSettingsActiveId].html); 

            blockHtml.find('[data-reference="' + vm.blockSettingsActiveRef + '"]').attr('src',data.src);
            vm.blocks[vm.blockSettingsActiveId].html = blockHtml.html()

            await this.$nextTick(); // Wait for dom to update

            vm.initMediumEditor();

            this.$bvModal.hide('modal-medialib-inline-image'); // Hide Modal


          },
          launchSetCardName: function(){
            this.$refs['set-cardname-modal'].show();
          },
          saveAsCustomBlock: function(){
            var blockName = this.$refs['set-cardname'].value;
            var vm = this;
            var block = this.blocks[vm.blockSettingsActiveId];

            const screenshotTarget = document.querySelector("#editable_block_"+ vm.blockSettingsActiveId+" .sd-block");

            screenshotTarget.classList.add("screenshot-in-progress");

            html2canvas(screenshotTarget).then((canvas) => {

              const base64image = canvas.toDataURL("image/png");
              const screenshot = base64image;

              const url = `/deck/save-user-block-tempate`;

              axios.post(url,{'block':block,'blockName':blockName,'screenshot':screenshot}).then(response => {

                screenshotTarget.classList.remove("screenshot-in-progress");

                if(!response.data.status){
                    new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 2000
                      }).show();

                }else{

                    new Noty({
                          text: response.data.message,
                          type: response.data.status,
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 1000
                      }).show();

                     vm.getBlockTemplates(false);

                }
                
              }).catch( error => {

                if(error.response.status == '419'){

                  new Noty({
                          text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show()

                }else{

                new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show();

                }

                

              });

            });

          },
          deleteCustomBlock: function (index) {
              this.closeSettings();

            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this custom card template?')
              .then(value => {
                if(value){
                  
                  var vm = this;
                  const url = `/deck/delete-user-block-tempate`;

                  axios.post(url,{'block_id':index}).then(response => {

                    if(!response.data.status){
                        new Noty({
                              text: 'There has been an error, please try saving again.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 2000
                          }).show();

                    }else{

                        new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                         vm.getBlockTemplates(false);

                    }
                    
                  }).catch( error => {

                    if(error.response.status == '419'){

                      new Noty({
                              text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show()

                    }else{

                    new Noty({
                              text: 'There has been an error, please try saving again.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show();

                    }

                    

                  });

                }
              })
              .catch(err => {
                // An error occurred
              })

          },
          launchSetCompanyCardName: function(){
            this.$refs['set-companycardname-modal'].show();
          },
          saveAsCompanyBlock: function(){
            var blockName = this.$refs['set-companycardname'].value;
            var vm = this;
            var block = this.blocks[vm.blockSettingsActiveId];

            const screenshotTarget = document.querySelector("#editable_block_"+ vm.blockSettingsActiveId+" .sd-block");


            html2canvas(screenshotTarget).then((canvas) => {

              const base64image = canvas.toDataURL("image/png");
              const screenshot = base64image;

              const url = `/deck/save-company-block-tempate`;

              axios.post(url,{'block':block,'blockName':blockName,'screenshot':screenshot}).then(response => {

                if(!response.data.status){
                    new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 2000
                      }).show();

                }else{

                    new Noty({
                          text: response.data.message,
                          type: response.data.status,
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 1000
                      }).show();

                     vm.getBlockTemplates(false);

                }
                
              }).catch( error => {

                if(error.response.status == '419'){

                  new Noty({
                          text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show()

                }else{

                new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show();

                }

                

              });

            });

          },
          deleteCompanyBlock: function (index) {
              this.closeSettings();

            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this company card template?')
              .then(value => {
                if(value){
                  
                  var vm = this;
                  const url = `/deck/delete-company-block-tempate`;

                  axios.post(url,{'block_id':index}).then(response => {

                    if(!response.data.status){
                        new Noty({
                              text: 'There has been an error, please try saving again.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 2000
                          }).show();

                    }else{

                        new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                         vm.getBlockTemplates(false);

                    }
                    
                  }).catch( error => {

                    if(error.response.status == '419'){

                      new Noty({
                              text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show()

                    }else{

                    new Noty({
                              text: 'There has been an error, please try saving again.',
                              type: 'error',
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: false
                          }).show();

                    }

                    

                  });

                }
              })
              .catch(err => {
                // An error occurred
              })

          },

          createFromTemplate: function(){
             var templateId = this.$refs['select-template'].value
             if(!templateId){

                new Noty({
                    text: 'Please select a template.',
                    type: 'warning',
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: 2000
                }).show();

             }else{
                window.location.href = "/deck/duplicate/"+templateId+'/?builder=true';
             }

          },

        },
        watch : {

          showProfile: function(){
            
            const url = `/deck/store`;
            var vm = this;
            axios.post(url,{id:vm.deckId,show_profile:vm.showProfile}).then(response => {
              
            }).catch(() => console.warn('Oh. Something went wrong'));
              
          },
          blockSettingsActive: function(){
            if(this.blockSettingsActive){this.editingImage = false;}
          },
          deckBodyFont: function(){
            $("head").append(this.deckBodyFont.embed);
            $("head").append('<style id="dynamicStyleBodyFont" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleBodyFont");
            newStyleElement.html('#buildArea,.note-editable{font-family:'+this.deckBodyFont["font-family"]+';}');
          },
          deckHeadingFont: function(){
            $("head").append(this.deckHeadingFont.embed);
            $("head").append('<style id="dynamicStyleHeadingFont" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleHeadingFont");
            newStyleElement.html('#buildArea h1,#buildArea h2,#buildArea h3,#buildArea h4,#buildArea h5,#buildArea h6,#buildArea .h1,#buildArea .h2,#buildArea .h3,#buildArea .h4,#buildArea .h5,#buildArea .h6,.note-editable h1,.note-editable h2,.note-editable h3,.note-editable h4,.note-editable h5,.note-editable h6,.note-editable .h1,.note-editable .h2,.note-editable .h3,.note-editable .h4,.note-editable .h5,.note-editable .h6{font-family:'+this.deckHeadingFont["font-family"]+';}');
          },
          deckAccentColor: function(){
            $("head").append('<style id="dynamicStyleAccentColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleAccentColor");
            newStyleElement.html('#buildArea .accent{color:'+this.deckAccentColor+';}#buildArea .avatar{ border-color:'+this.deckAccentColor+';}#buildArea .border-accent{ border-top-color:'+this.deckAccentColor+';border-left-color:'+this.deckAccentColor+';border-bottom-color:'+this.deckAccentColor+';border-right-color:'+this.deckAccentColor+';}#buildArea .background-accent,#buildArea .sd-block.background-accent{background-color:'+this.deckAccentColor+';}#buildArea a:not(.social-icon,.ground){color:'+this.deckAccentColor+';}#buildArea .sd-block ul li::before{color:'+this.deckAccentColor+';}#buildArea .sd-block ol li::before{color:'+this.deckAccentColor+';}');
          },
          deckSecondaryColor: function(){
            $("head").append('<style id="dynamicStyleSecondaryColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleSecondaryColor");
            newStyleElement.html('#buildArea .secondary{color:'+this.deckSecondaryColor+';}#buildArea .border-secondary{ border-top-color:'+this.deckSecondaryColor+';border-left-color:'+this.deckSecondaryColor+';border-bottom-color:'+this.deckSecondaryColor+';border-right-color:'+this.deckSecondaryColor+';}#buildArea .background-secondary,#buildArea .sd-block.background-secondary{background-color:'+this.deckSecondaryColor+';}');
          },
          deckTertiaryColor: function(){
            $("head").append('<style id="dynamicStyleTertiaryColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleTertiaryColor");
            newStyleElement.html('#buildArea .tertiary{color:'+this.deckTertiaryColor+';}#buildArea .border-tertiary{ border-top-color:'+this.deckTertiaryColor+';border-left-color:'+this.deckTertiaryColor+';border-bottom-color:'+this.deckTertiaryColor+';border-right-color:'+this.deckTertiaryColor+';}#buildArea .background-tertiary,#buildArea .sd-block.background-tertiary{background-color:'+this.deckTertiaryColor+';}');
          },
          deckContrastColor: function(){
            $("head").append('<style id="dynamicStyleContrastColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleContrastColor");
            newStyleElement.html('#buildArea, #buildArea .sd-block, #buildArea .sd-block.skin-light, #buildArea .contrast{color:'+this.deckContrastColor+';} #buildArea .background-contrast{background-color:'+this.deckContrastColor+';}');
          },
          deckGroundColor: function(){
            $("head").append('<style id="dynamicStyleGroundColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleGroundColor");
            newStyleElement.html('#buildArea .sd-block.skin-dark, #buildArea .ground{color:'+this.deckGroundColor+';}#buildArea .background-ground,#buildArea .sd-block{background-color:'+this.deckGroundColor+';}');
          },
          dynamicOgImage: function(){
            var vm = this;
            if(vm.dynamicOgImage){
              const url = `/deck/store`;
              axios.post(url,{id:this.deckId,og_image_static:null}).then(response => {
                 this.staticOgImage = null;
              }).catch(() => console.warn('Oh. Something went wrong'));

            }
          }

        }
    }
</script>
